import { Box } from "@mui/material";
import { FC, useState } from "react";

import { Switch } from "@/modules/irohana-components/elements/Switch";

type TProductActiveSwitchProps = {
  productId: number;
  isActive: boolean;
  /** Returns whether the update succeeded (false -> the switch reverts). */
  onToggle: (id: number, nextActive: boolean) => Promise<boolean>;
};

/**
 * 商品設定 column — active / deactivate toggle. Optimistic UI; the parent hook shows the
 * success / failure toast and reverts on failure. `nonControl` keeps the switch out of any
 * surrounding react-hook-form context. The wrapper zeroes the shared Switch's FormControlLabel
 * margins (which otherwise shift/clip the switch inside the narrow cell) and centers it.
 */
export const ProductActiveSwitch: FC<TProductActiveSwitchProps> = ({ productId, isActive, onToggle }) => {
  const [pending, setPending] = useState(false);

  const handleChange = async (_e: unknown, checked: boolean) => {
    if (pending) return;
    setPending(true);
    await onToggle(productId, checked);
    setPending(false);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", "& .MuiFormControlLabel-root": { m: 0 } }}>
      <Switch nonControl checked={isActive} disabled={pending} onChange={handleChange} />
    </Box>
  );
};
